import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import s from './UploadType.module.sass';
import { useTranslation } from 'react-i18next';

const UploadType = ({ onSubmit }) => {
  const { t } = useTranslation('upload');
  const { handleSubmit, control, formState: { errors } } = useFormContext();

  const validateRadio = (value) => {
    return typeof value === 'boolean' ? true : 'error';
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h4>{t('uploadType.header')}</h4>
      <label>{t('uploadType.label')}</label>
      <div className={s['upload-form']}>
        <Controller
          name="gdpr.hasPersonalDetails"
          control={control}
          rules={{ validate: validateRadio }}
          render={({ field, fieldState: { error } }) => (
            <>
              <div>
                <label htmlFor="gdpr-no-personal-details">
                  <input 
                    id="gdpr-no-personal-details"
                    type="radio"
                    name="gdpr.hasPersonalDetails"
                    ref={field.ref}
                    checked={field.value === false}
                    onChange={() => field.onChange(false)}
                    onBlur={field.onBlur}
                  />
                  {' '}
                  {t('uploadType.field.label1')}
                </label>
              </div>
              <div>
                <label htmlFor="gdpr-has-personal-details">
                  <input 
                    id="gdpr-has-personal-details"
                    type="radio"
                    name="gdpr.hasPersonalDetails"
                    checked={field.value === true}
                    onChange={() => field.onChange(true)}
                    onBlur={field.onBlur}
                  />
                  {' '}
                  {t('uploadType.field.label2')}
                </label>
              </div>
              {error && (
                <span className="help-text help-text--has-error">
                  {t(`uploadType.validate.${error.message}`)}
                </span>
              )}
            </>
          )}
        />
      </div>
      <button type="submit" className="btn btn--primary">
        {t('uploadType.button')}
      </button>
    </form>
  );
};

export default UploadType;